import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

import DialogModal from '../../common/DialogModal';
import BillingAddressForm from '../../common/BillingAddressForm';
import Button from '../../Parts/Button';

import { validateAddressItem, validateProperty, numHyphen } from '../../../utils/validator'
import { countries } from '../../../constants/ComponentTypes'

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  contentContainer: {
    padding: '0 25px 25px 25px',
    margin: 0,
    textAlign: 'left',
  },

  buttonContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-evenly',
    margin: '40px 0',
  }
});

class BillingAddressDialog extends React.Component {
  constructor(props) {
    super(props);

    let initialState = {
      company: '',
      branch: '',
      name: '',
      country_id: countries.JAPAN.ISO,
      post_code: '',
      address: '',
      tel: '',
      email: '',
      error: {},
      saveBtnPressed: false,
    }

    if (props.paymentInfo) {
      for (let key in initialState) {
        initialState[key] = props.paymentInfo["bill_" + key] ?
          props.paymentInfo["bill_" + key] :
          initialState[key];
      }
    }

    this.state = { ...initialState }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isSaving && !nextProps.isSaving && nextProps.error === null) {
      nextProps.toggleDialog();
    }

    // APIから返されたプロパティ名はすべてbillが付いているので外す
    if (nextProps.error) {
      let error = {};
      for (let key in nextProps.error) {
        if (key.startsWith('bill_')) {
          let index = key.replace(/^bill_/, '');
          error[index] = nextProps.error[key];

          for (let p in error[index]) {
            error[index][p] = error[index][p].replace(/(^bill\s|^bill_)/, '');
          }
        } else {
          error[key] = nextProps.error[key];
        }
      }
      this.setState({
        error: error
      })
    }
  }

  handleChange = property => event => {
    let value = event.target.value;

    //２回目からタイピングごとでチェック
    if (this.state.saveBtnPressed) {
      this.validateInput(property, value);
    }

    this.setState({
      [property]: value,
    });
  };

  handleSave = () => {
    let { error, saveBtnPressed, ...addressInfo } = this.state;
    if (!saveBtnPressed) error = this.validateForm();

    if (Object.keys(error).length === 0) {
      //take out hyphens in postcode,tel,fax
      for (let p in addressInfo) {
        if (p === "post_code" || p === "tel" || p === "fax") {
          addressInfo[p] = numHyphen(addressInfo[p]);
        }
      }
      this.props.updatePaymentInfo(addressInfo);
    } else {
      this.setState({
        saveBtnPressed: true,
      });
    }
  }

  validateForm = () => {
    let error = validateAddressItem(this.state);

    this.setState({
      error: error,
    });

    return error;
  }

  validateInput = (p, value) => {
    let error = this.state.error;

    //clear error before update
    if (error.hasOwnProperty(p)) delete error[p];

    //update error
    let err = validateProperty(value, this.state, p);
    Object.assign(error, err);

    this.setState({
      error: error,
    });
  };

  countErrors = () => {
    return Object.keys(this.state.error).length;
  }

  render() {
    const { classes, toggleDialog, isSaving } = this.props;

    return (
      <DialogModal
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
        open={this.props.isOpen}
        maxWidth={false}
        onClose={toggleDialog}
        title="請求先情報を編集"
      >
        <BillingAddressForm
          values={this.state}
          errors={this.state.error}
          handleChange={this.handleChange}
        />

        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={this.handleSave}
            size="large"
            disabled={this.countErrors() !== 0}
            loading={isSaving}
            text="保存"
          >
          </Button>
        </div>
      </DialogModal>
    );
  }
}

BillingAddressDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  paymentInfo: PropTypes.object,
  toggleDialog: PropTypes.func.isRequired,
  updatePaymentInfo: PropTypes.func.isRequired,
  isSaved: PropTypes.bool,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
};

export default withStyles(styles)(BillingAddressDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Billing/BillingAddressDialog.jsx